import { cx } from 'linaria';
import PropTypes from 'prop-types';
import React from 'react';
import { AD_LABEL_TARGET, AD_LABEL_VIEW_MODE } from './helpers';
import Styles from './ImageLabel.module.scss';

const getAdLabelStyle = (config) => {
  // Mobile
  if (config.isMobile) {
    if (config.target === AD_LABEL_TARGET.adView) {
      return Styles.mobileAdviewOverlay;
    } else {
      if (config.viewMode === AD_LABEL_VIEW_MODE.gridView) {
        return Styles.gridViewOverlay;
      }
      return Styles.mobileListviewOverlay;
    }
  }
  // Desktop
  if (config.target === AD_LABEL_TARGET.adView) {
    return Styles.webAdviewOverlay;
  } else {
    if (config.viewMode === AD_LABEL_VIEW_MODE.gridView) {
      return Styles.gridViewOverlay;
    }
    return Styles.webListviewOverlay;
  }
};

const ImageLabel = ({ config }) => {
  const style = getAdLabelStyle(config);
  return (
    <div className={cx(style)}>
      <img id="ad-label-image" src={config.image} alt="" />
    </div>
  );
};

ImageLabel.propTypes = {
  config: PropTypes.shape({
    image: PropTypes.string,
    isMobile: PropTypes.bool,
  }).isRequired,
};

export default ImageLabel;